<template>
  <div class="d-flex flex-column">
    <span class="text-capitalize-first">
      {{ helper.trans(`antifraudalerts.rule.${alert.rule}`) }}
    </span>
    <div class="text-danger">
      <i class="fa fa-warning"></i> <span class="text-capitalize-first">{{$t(`antifraudalerts.description.uzs_pay_in_canceled_deals_count_check.default`, {count: data?.count, requisite: data?.requisite})}}</span>
    </div>
    <div v-if="data?.trafficBlocked" class="text-danger text-capitalize-first">
      <i class="fa fa-warning"></i> <span class="text-capitalize-first d-inline-block">{{ $t(`antifraudalerts.description.uzs_pay_in_canceled_deals_count_check.traffic_blocked`) }}, id: {{data?.requisiteId }}</span>
    </div>
  </div>
</template>

<script lang="ts">

import {computed, defineComponent, Prop, PropType} from 'vue'
import {$t, helper} from "@/service/CommonHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import AntiFraudAlertDTO from "@/models/AntiFraudAlertDTO";
import CopyButton from "@/components/CopyButton.vue";

interface UZSPayInCanceledDealsCountCheckDataDTO {
  trafficBlocked: boolean
  count: number
  requisiteId: number|null
  requisite: string|null
}


export default defineComponent({
  name: "UZSPayInCanceledDealsCountCheckDescription",
  methods: {$t},
  components: {CopyButton},
  props: {
    alert: {
      type: Object as PropType<AntiFraudAlertDTO>,
      default: null
    } as Prop<AntiFraudAlertDTO>,
  },
  setup(props) {
    const data = computed((): UZSPayInCanceledDealsCountCheckDataDTO | null => {
      if (!props.alert) {
        return null
      }

      return props.alert.data as unknown as UZSPayInCanceledDealsCountCheckDataDTO
    })

    return {
      helper,
      numberFormatter,
      data
    }
  }
})
</script>
